export const serviceName = 'NucleusThemeLifeV1';
